module.exports = __webpack_public_path__ + "static/media/uoa-26.157cd974.jpg";